import {isNotNil} from 'ramda-adjunct';

import {Nullish, precisionCalculation} from 'shared/web';

const TOTAL_RATIO = 100;

type AssignedMechanic = {
  ratio?: number | null;
};

/**
 * Validates that the assigned mechanics' ratios add up to the full 100%.
 * Returns `true` when there are no mechanics to validate (nothing to check).
 */
export const isMechanicsRatioEqualToTotalRatio = (
  assignMechanics: (AssignedMechanic | Nullish)[] | Nullish
) => {
  if (isNotNil(assignMechanics)) {
    const ratioSum = assignMechanics.reduce(
      (total, mechanic) => precisionCalculation.add(total, mechanic?.ratio ?? 0),
      0
    );

    return ratioSum === TOTAL_RATIO;
  }

  return true;
};
